/**
 * WordPress dependencies
 */
import { ColorPalette } from '@wordpress/components';
/**
 * Internal dependencies
 */

import withColorContext from './with-color-context';
export default withColorContext(ColorPalette);
//# sourceMappingURL=index.js.map